module.exports = __webpack_public_path__ + "static/assets/63dd5eb56ac4ea66e88b30e089fe9b5f.png";